"use client";

import LogoLoop from "@/components/logo-loop";
import type { Brand } from "./testimonials";

interface BrandLogosProps {
    brands: Brand[];
}

export function BrandLogos({ brands }: BrandLogosProps) {
    const logoItems = brands.map(brand => {
        if (brand.logo) {
            return {
                node: (
                    <div className="flex items-center gap-3 group/logo">
                        <div className="w-10 h-10 flex items-center justify-center overflow-hidden">
                            {/* eslint-disable-next-line @next/next/no-img-element */}
                            <img
                                src={brand.logo}
                                alt={`${brand.name} logo`}
                                className="w-full h-full object-contain grayscale group-hover/logo:grayscale-0 transition-all duration-300"
                            />
                        </div>
                        <span className="text-white/70 text-xl font-light tracking-wider">
                            {brand.name}
                        </span>
                    </div>
                ),
                title: brand.name,
                ariaLabel: brand.name
            };
        }
        return {
            node: (
                <div className="flex items-center gap-3">
                    <div className="w-10 h-10 bg-white/10 rounded-full border border-white/20 flex items-center justify-center">
                        <span className="text-white text-sm font-bold">
                            {brand.name.charAt(0)}
                        </span>
                    </div>
                    <span className="text-white/70 text-xl font-light tracking-wider">
                        {brand.name}
                    </span>
                </div>
            ),
            title: brand.name,
            ariaLabel: brand.name
        };
    });

    return (
        <LogoLoop
            logos={logoItems}
            speed={80}
            direction="left"
            logoHeight={80}
            gap={100}
            pauseOnHover={true}
            scaleOnHover={true}
            fadeOut={true}
            fadeOutColor="#000000"
            ariaLabel="Partner logos"
            className="py-6"
        />
    );
}

